import { SettingsService } from "@/services/settings.service"
import { mapGetters } from "vuex";
import { yearGroupMixin } from "@/mixins/yearGroupMixin.js";


export const settingsMixin = {
  mixins: [yearGroupMixin],
   computed: {
    ...mapGetters({
      currentUser: "currentUser",
      settings: "settings"
    }),

   },
   data () {
       return {
         loading: false,
         errored: false,
         hasCompleted: false,
         gradesConfig: [],
         criteriaConfig: {},
         fieldsList: [],
         yearsList: [],
         planningLevelSelected: 0,
         isGcseActive: false,
         isPlanningLocked: false,
         isAssessmentCustom: false,
         isAllowedFree: true
      }

   },
   created: function () {

    this.criteriaConfig = this.settings.assessmentCriteria
    this.gradesConfig = this.settings.assessmentGrades
    
    this.fieldsList = this.settings.fieldDisplayList
    this.planningLevelSelected = this.settings.planningLevel
    this.isGcseActive = this.settings.gcseActive
    this.isPlanningLocked = this.settings.planningLocked
    this.isAssessmentCustom = this.settings.assessmentCustom

    let yearTitleValues = this.settings.yearTitlesList.length > 0
          ? this.settings.yearTitlesList
          : this.years.map((y) => ({ value: y.value, title: y.name }));

    this.yearsList = yearTitleValues
   },
   methods: {
    async refreshSettings() {
      this.$store
      .dispatch("configure")
      .catch((err) => {
        console.log("SETTING EOROR", err)
      })
      .finally(() => {
        this.$emit("settingsRefresh")
      });
      
    },
    completed() {
      this.loading = false
      this.hasCompleted = true
      this.refreshSettings()
    
    },
    saveSettings() {
      this.loading = true

      let payload = {
        course_fields: this.fieldsList,
        year_titles: this.yearsList,
        is_planning_locked: this.isPlanningLocked,
        is_assessment_custom: this.isAssessmentCustom,
        planning_level: this.planningLevelSelected,
        is_gcse_active: this.isGcseActive,
        gcse_board: this.settings.gcseBoard,
        course_criteria: this.settings.courses,
        outcome_criteria: this.settings.outcomes,

     
      }

      if (this.settings.id === undefined || this.settings.id < 1) {
        this.insertSetting(payload)
      } else {
        this.updateSetting(payload)
      }
    },
    insertSetting(payload) {
      SettingsService.add(payload)
        .then((response) => this.parseSettingAddition(response.data))
        .catch((err) => {
          this.errored = true;
          this.loading = false
          console.log("Criteria config add error " + err);
        })
    },
    parseSettingAddition(data) {
      this.settings.id = data.id;
      this.completed();
    },
    updateSetting(payload) {
      SettingsService.update(this.settings.id, payload)
        .then((response) => this.completed())
        .catch((err) => {
          this.errored = true;
          this.loading = false
          console.log("Config update error " + err);
        })
    },
    saveSettingsCriteria() {
      this.loading = true

      var payload = {}
      this.criteriaConfig.values.forEach(element => {
        payload[element.key] = element.used ? element.value : null
      });

      if (this.criteriaConfig.id === undefined || this.criteriaConfig.id === -1) {
        SettingsService.addCriteria(payload)
        .then((response) => this.completed())
        .catch((err) => {
          this.errored = true;
          this.loading = false
          console.log("Criteria config add error " + err);
        })
      } else {
        SettingsService.updateCriteria(this.criteriaConfig.id, payload)
        .then((response) => this.completed())
        .catch((err) => {
          this.errored = true;
          this.loading = false
          console.log("Config update error " + err);
        })
      }
    },
    saveSettingsGrades() {
      this.loading = true

      var payload = {}
      this.gradesConfig.values.forEach(element => {
        payload[element.key] = element.used ? element.value : null
      });

      if (this.gradesConfig.id === undefined || this.gradesConfig.id === -1) {
        SettingsService.addGrades(payload)
        .then((response) => this.completed())
        .catch((err) => {
          this.errored = true;
          this.loading = false
          console.log("Criteria config add error " + err);
        })
      } else {
        SettingsService.updateGrades(this.gradesConfig.id, payload)
        .then((response) => this.completed())
        .catch((err) => {
          this.errored = true;
          this.loading = false
          console.log("Config update error " + err);
        })
      }
    }
   }
}